import React, { FC, memo } from "react";
import "./style.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { IPopup } from "./popup.types/popup.type";

const Popup: FC<IPopup> = ({ name, title, large, onClose, children }) => {
  return (
    <div
      className={`modal fade popup`}
      id={name}
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
      onClick={onClose}
    >
      <div
        className={`modal-dialog modal-dialog-centered ${large ? "modal-xl" : ""}`}
        role="document"

      >
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-body">
            <div className="header-title">
              <div className="title">{title}</div>
              <div className="close" onClick={onClose}>
                <Icon icon="fluent:dismiss-24-filled" />
              </div>

            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Popup);
